import { type ReactNode } from 'react';
import { ModuleLayout, ModuleSidebar } from '@ah/design';
import { Video, CalendarCheck, History } from 'lucide-react';

const sections = [
  {
    items: [
      { to: '/gatherings', label: 'Upcoming', icon: <Video size={16} /> },
      { to: '/gatherings/attending', label: 'Attending', icon: <CalendarCheck size={16} /> },
      { to: '/gatherings/past', label: 'Past', icon: <History size={16} /> },
    ],
  },
];

export function GatheringsLayout({ children }: { children: ReactNode }) {
  return (
    <ModuleLayout
      sidebar={
        <ModuleSidebar
          title="Gatherings"
          sections={sections}
        />
      }
    >
      {children}
    </ModuleLayout>
  );
}
